<div class="apa-card">
  <div class="apa-title">{{ data?.title || 'APA RANGES' }}</div>
  <div class="apa-grid" *ngIf="rows.length; else emptyState">
    <div class="apa-row" *ngFor="let row of rows">
      <div class="label">{{ row.label }}</div>
      <div class="min">{{ row.min }}%</div>
      <div class="track">
        <div class="fill" [style.width.%]="getPositionPercent(row)"></div>
        <div class="marker" [style.left.%]="getPositionPercent(row)"></div>
        <input
          class="slider-hit"
          type="range"
          [min]="row.min"
          [max]="row.max"
          [step]="getStep(row)"
          [value]="row.currentValue"
          (input)="onSlide(row, $event)"
        />
        <div class="value" [style.left.%]="getPositionPercent(row)">{{ row.currentValue }}%</div>
      </div>
      <div class="max">{{ row.max }}%</div>
    </div>
  </div>
  <ng-template #emptyState>
    <div class="empty">No APA ranges available.</div>
  </ng-template>
</div>
